import axios from 'axios';
import { handleLogout } from '../../utils';
import { errorToast, showToast } from '../../utils/toast';
import { setLoading } from '../slices/loadingSlice';
import { store } from '../store';
import { baseURL } from '../../components/config';

import { decodeId, recursiveDecode } from '../../helper/hashids';

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    if (config.url) {
      const parts = config.url.split('/');
      const decodedParts = parts.map((part) => {
        const decoded = decodeId(part);
        return decoded !== part ? decoded : part;
      });
      config.url = decodedParts.join('/');
    }

    if (config.params) config.params = recursiveDecode(config.params);
    if (config.data) config.data = recursiveDecode(config.data);

    let token = localStorage.getItem('token');

    if (token) {
      token = JSON.parse(localStorage.getItem('token'));
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      handleLogout();
      return;
    }
    return Promise.reject(error);
  }
);

const handleRequest =
  (method) =>
  async (url, data, config = { loading: true, toast: true, throwError: true }) => {
    if (!navigator.onLine) return;
    try {
      const { loading } = config;

      if (loading || loading === undefined) store.dispatch(setLoading(true));

      const response = await axiosInstance.request({
        method,
        url,
        data,
        ...{ ...config, signal: config.source?.signal },
      });

      if (method !== 'get' && config.toast) {
        if (response?.data?.ack) showToast(response?.data?.message);
        else errorToast(response?.data?.message);
      }

      return config.responseType === 'blob' ? response : response?.data;
    } catch (error) {
      if (error.code === 'ERR_CANCELED') return error.code;
      if (error?.response?.status === 401) {
        handleLogout();
        return;
      }
      errorToast(error?.response?.data?.message || 'Something went wrong.');
    } finally {
      store.dispatch(setLoading(false));
    }
  };

const handleGetRequest = handleRequest('get');
const handlePostRequest = handleRequest('post');
const handlePutRequest = handleRequest('put');
const handleDeleteRequest = handleRequest('delete');
const handlePatchRequest = handleRequest('patch');

export {
  handleDeleteRequest,
  handleGetRequest,
  handlePatchRequest,
  handlePostRequest,
  handlePutRequest,
};
